import { render } from "./LikeBtnWrap.vue?vue&type=template&id=70d475fc&ts=true"
import script from "./LikeBtnWrap.vue?vue&type=script&lang=ts"
export * from "./LikeBtnWrap.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/macbook/Documents/work_code/global/events_gevents.37games.com/src/resource/guidetro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__